module.exports = __webpack_public_path__ + "img/cams.cfa8961.png";